/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentRequest
 */
export interface PaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentRequest
     */
    paymentProviderUrl?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaymentRequest
     */
    params?: { [key: string]: string; };
}

/**
 * Check if a given object implements the PaymentRequest interface.
 */
export function instanceOfPaymentRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentRequestFromJSON(json: any): PaymentRequest {
    return PaymentRequestFromJSONTyped(json, false);
}

export function PaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentProviderUrl': !exists(json, 'paymentProviderUrl') ? undefined : json['paymentProviderUrl'],
        'params': !exists(json, 'params') ? undefined : json['params'],
    };
}

export function PaymentRequestToJSON(value?: PaymentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentProviderUrl': value.paymentProviderUrl,
        'params': value.params,
    };
}

